import React, {useState, useRef, useEffect} from 'react';
import * as EditorHelpers from '../utilities/EditorHelpers';
import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as GoThroughItem from './GoThroughItem';
import AlertPiece from './AlertPiece';
import * as HolderWrapperFn from '../ContentItems/HolderWrapperFn';

function App(props) {

  var relativeSize = props.relativeSize;
  var actualWidth = props.actualWidth;
  var insetWidth = props.insetWidth;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var internalVariables = props.internalVariables;
  var refObject = props.refObject;
  var getRef1 = props.getRef1;

  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var error = props.error;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var alertVisibility = props.alertVisibility;
  var insetHeight = props.insetHeight;
  var interactionFn = props.interactionFn
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var doAScreenRef = props.doAScreenRef;
  var addWhereText = props.addWhereText;
  var style = props.style;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var panelPath = props.panelPath;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var flashHighlight = props.flashHighlight;
  var changeTab = props.changeTab;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  var thisScreen = CoreFns.goDownPath(currentList, panelPath);
  var upwardInfo = [];

  const ref1 = useRef();

  var panelPathStringBlank = panelPath.join(' ');

  useEffect(()=>{
    doAScreenRef(ref1, panelPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [isDraggingDetails, setIsDraggingDetails] = useState(false);

  var showRelatives = true;
  if (hidePanelRelativeItems[panelPathStringBlank]){
    showRelatives = false;
  }

  function clickEditItem(x){
    return function(e){
      if (setItemEdited){
        setItemEdited(x);
        changeTab('ElementStyle', 0);
        setIsClickingOnContentDiv(false);
      }
      e.stopPropagation();
    }
  }

  function dragStart(t, itemToHighlight){
    return function(e){
      setIsDraggingDetails({t, clientX:e.screenX, clientY:e.screenY, currentX:e.screenX, currentY:e.screenY});
      if (t === 'all' && itemToHighlight){
        setItemEdited({t:'item', path:itemToHighlight})
      }
      var img = new Image(0, 0);
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
      e.dataTransfer.setDragImage(img, window.outerWidth, window.outerHeight);    
    }
  }

  function dragEnd(e){

    if (isDraggingDetails.t === 'screenBottom'){
      var screenHV = EditorHelpers.changeScreenHeight(thisScreen, isDraggingDetails, insetWidth, insetHeight); 
      var changes1 = [{t:'w',w:(itemEdited.path).concat(['h', 'v']),n:screenHV}];
      organicChanges(changes1);
    }else{
      var pathDown = itemEdited.path;
      var thisItem = CoreFns.goDownPath(currentList, pathDown);

      var pos = thisItem.pos;
      var considerationSet1 = EditorHelpers.getConsiderationSet(pos, true, isDraggingDetails, insetWidth, insetHeight, thisItem);


      var newOut = {ud:pos.ud, lr:pos.lr};

      if (pos.lr.v === 0 || pos.lr.v === 1){
        newOut.l = {t:pos.l.t,v:considerationSet1.lv};
      }
      if (pos.lr.v === 0 || pos.lr.v === 2){
        newOut.w = {t:pos.w.t,v:considerationSet1.wv};
      }
      if (pos.lr.v === 1 || pos.lr.v === 2){
        newOut.r = {t:pos.r.t,v:considerationSet1.rv};
      }

      if (pos.ud.v === 0 || pos.ud.v === 1 || pos.ud.v === 3 || pos.ud.v === 5){
        newOut.t = {t:pos.t.t,v:considerationSet1.tv};
      }

      if (pos.ud.v === 0 || pos.ud.v === 2){
        newOut.h = {t:pos.h.t,v:considerationSet1.hv};
      }
      if (pos.ud.v === 1 || pos.ud.v === 2 || pos.ud.v === 4 || pos.ud.v === 6){
        newOut.b = {t:pos.b.t,v:considerationSet1.bv};
      }

      var changes = [{t:'w',w:pathDown.concat(['pos']),n:newOut}];

      if (isDraggingDetails.t === 'leftMiddle'){
        changes.push({t:'w',w:pathDown.concat(['info', 'cL', 'v']), n:considerationSet1.cLv});
      }else if (isDraggingDetails.t === 'rightMiddle'){
        changes.push({t:'w',w:pathDown.concat(['info', 'cR', 'v']), n:considerationSet1.cRv});
      }else if (isDraggingDetails.t === 'topMiddle'){
        changes.push({t:'w',w:pathDown.concat(['info', 'cT', 'v']), n:considerationSet1.cTv});
      }else if (isDraggingDetails.t === 'bottomMiddle'){
        changes.push({t:'w',w:pathDown.concat(['info', 'cB', 'v']), n:considerationSet1.cBv});
      }

      organicChanges(changes);
    }
    setIsDraggingDetails(false);
  }

  function onDrag(e){

    if (isDraggingDetails){
      if (e.screenX && e.screenY){
        isDraggingDetails.currentX = e.screenX;
        isDraggingDetails.currentY = e.screenY;
        setIsDraggingDetails({...isDraggingDetails});
      }
    }
  }


  function clickScreen(e){
    if (!interactionFn){
      setItemEdited({t:'screen', path:panelPath})
    }
    e.stopPropagation();        
  }

  var isThisPanelEdited = false;
  var isThisPanelItemEdited = false;
  var aScreenStyle = {width:actualWidth, position:'relative', overflow:'hidden'};

  if (thisScreen && thisScreen.h){
    var thisScreenHV = thisScreen.h.v;
    if (!interactionFn){
      if (itemEdited && itemEdited.t === 'screen' && itemEdited.path.join(' ') === panelPathStringBlank){
        isThisPanelEdited = true;
        thisScreenHV = EditorHelpers.changeScreenHeight(thisScreen, isDraggingDetails, insetWidth, insetHeight); 
      }
      if (itemEdited && itemEdited.path.join(' ').indexOf(panelPathStringBlank) === 0){
        isThisPanelItemEdited = true;
      }
    }
    function getLocFromDimensions(t, v, changeWhat){
      return EditorHelpers.reverseScale(v, t, changeWhat, insetWidth, insetHeight);
    }

    var screenClassNames = '';
    if (thisScreen.hl){
      if (thisScreen.hl.v === 1){
        var screenH = getLocFromDimensions(thisScreen.h.t, thisScreenHV, 'h');
        aScreenStyle.height = screenH;
      }

    }else{ //transitions for old templates; should be removed.
      aScreenStyle.height =  getLocFromDimensions(thisScreen.h.t, thisScreenHV, 'h');

    }
  }


  StyleFunctions.modStyleWithFlashHighlight(aScreenStyle, flashHighlight, panelPathStringBlank);

  var choices = [];

  if (!interactionFn){
    screenClassNames = 'nonEditingMode';
    if (isThisPanelEdited){
      screenClassNames = 'editing';
      if (thisScreen.hl){
        if (thisScreen.hl.v === 1){
          choices = [{t:'screenBottom', left:aScreenStyle.width / 2, top:aScreenStyle.height}];
        }
      }
    }else if (hoveringWhere === panelPathStringBlank){
      screenClassNames = 'preEditing';
    }
  }

  if (panelPath[0] === 'fo' && interactionFn){
    if (thisScreen.s.footerSticky){
        aScreenStyle.position = 'sticky';
        aScreenStyle.bottom = 0;      

    }
  }

  var panelOffsetT = 0;
  var panelOffsetL = 0;

  if (ref1 && ref1.current){
    panelOffsetT = offsetTop + ref1.current.offsetTop ;
    panelOffsetL = offsetLeft + ref1.current.offsetLeft;
  }

  StyleFunctions.sortOutBackgroundColor(aScreenStyle, thisScreen.s, panelPath, currentList, internalVariables, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, {interactionFn, relativeSize, panelOffsetT, panelOffsetL});

  var minHeight = StyleFunctions.getStyleValueR('minHeight', thisScreen, panelPath, currentList, internalVariables, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  aScreenStyle.minHeight = minHeight;


  var items = thisScreen.i;
  var relativeItems = thisScreen.k;
  if (!relativeItems){
    relativeItems = {};
  }

  var frontExpressedItemsSet = GoThroughItem.goThroughItems(items, chains, 'front', panelPath, interactionFn, itemEdited, setItemEdited, isDraggingDetails, insetWidth, insetHeight, dragStart, dragEnd, onDrag, isShowingSomeDropDown, currentList, otherPeoplesPositions, updatesToPropagate, organicChanges, userNos, userID, getRef1, refObject, error, internalVariables, clickEditItem, onClickItemChangeSelection, inputValues, setInputValues, ownVariables, urlParamsForExecution, urlHeader, setIsShowingSomeDropDown, setIsClickingOnContentDiv, upwardInfo, isClickingOnContentDiv, addWhereText, potentiallyAddWhichItem, hoveringWhere, actHoveringWhere, screenSelectionChoices, setScreenSelectionChoices, popUps, setPopUps, true, doAScreenRef, flashHighlight, lastEdited, counter);
  var frontExpressedItems = frontExpressedItemsSet.expressedItems;
  var frontAddChoices = frontExpressedItemsSet.choices;



  var movementPieces = choices.concat(frontAddChoices).map((aChoice, index)=>{
    var cursor = 'nesw-resize' 
    if (aChoice.t === 'leftTop' || aChoice.t === 'rightBottom'){
      cursor = 'nwse-resize'
    }else if (aChoice.t === 'leftBottom' || aChoice.t === 'rightTop'){
    }else if (aChoice.t === 'leftMiddle' || aChoice.t === 'rightMiddle'){
    }else if (aChoice.t === 'topMiddle' || aChoice.t === 'bottomMiddle' || aChoice.t === 'screenBottom'){
    }else{
      console.warn(aChoice.t);
    }
    var loc = {position:'absolute', height:15, width:15, left:aChoice.left - 7.5, border:'1px solid blue', borderRadius:7.5, cursor, zIndex:130};
    if (aChoice.top !== undefined){
      loc.top = aChoice.top - 7.5;
    }

    if (aChoice.bottom !== undefined){
      loc.bottom = aChoice.bottom - 7.5;
    }
    return <div key={index} style={loc} className='movementCircle' draggable={true} onDragStart={dragStart(aChoice.t, false)}  onDragEnd={dragEnd} onDrag={onDrag} ></div>

  })
//
  var alerts = thisScreen.al;
  var alertPieces = [];
  if (alerts){
    var sortedAlertKeys = ResponsiveFns.sortAListBasedOnOrd(alerts);
    var a1 = sortedAlertKeys.filter((anAlertKey, index)=>{
      if (!interactionFn){
        return true;
      }else{
        var alertPath = panelPath.concat(['al', anAlertKey]).join('_');
        if (alertVisibility[alertPath]){
          return false;
        }else{
          return true;
        }
      }
    }).map((anAlertKey, index)=>{

      var thisAlertVariant = alerts[anAlertKey];
      var alertPath = panelPath.concat(['al', anAlertKey]);

      return (<AlertPiece chains={chains} thisAlertVariant={thisAlertVariant} alertPath={alertPath} currentList={currentList} internalVariables={internalVariables} insetWidth={insetWidth} insetHeight={insetHeight} upwardInfo={upwardInfo} inputValues={inputValues} ownVariables={ownVariables} itemEdited={itemEdited} error={error} interactionFn={interactionFn} isDraggingDetails={isDraggingDetails} popUps={popUps} setPopUps={setPopUps} setItemEdited={setItemEdited} getRef1={getRef1} organicChanges={organicChanges} otherPeoplesPositions={otherPeoplesPositions} dragStart={dragStart} dragEnd={dragEnd} updatesToPropagate={updatesToPropagate} userNos={userNos} userID={userID} setInputValues={setInputValues} isShowingSomeDropDown={isShowingSomeDropDown} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices}  hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} potentiallyAddWhichItem={potentiallyAddWhichItem} addWhereText={addWhereText} isClickingOnContentDiv={isClickingOnContentDiv} setIsClickingOnContentDiv={setIsClickingOnContentDiv} onDrag={onDrag} refObject={refObject} clickEditItem={clickEditItem} onClickItemChangeSelection={onClickItemChangeSelection} setIsShowingSomeDropDown={setIsShowingSomeDropDown} showRelatives={showRelatives} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>)

    })

    if (itemEdited && itemEdited.t === 'alert'){
      alertPieces = HolderWrapperFn.doActualWrap(sortedAlertKeys, panelPath, 'al', itemEdited, setItemEdited, currentList, organicChanges, 'alert', a1, actualWidth)
    }else{
      alertPieces = a1;
    }

  }

  if (!interactionFn){
    if (addWhereText === 'PANEL' && potentiallyAddWhichItem.t === 'ALERT' && isThisPanelEdited){
      alertPieces.push(<div className='alert alert-primary'>Click and Banner will be added here</div>)
//
    }
  }

  var relativePieces;
  var addRelativePiece = null;
  var relativeItemsSet = GoThroughItem.goThroughItems(relativeItems, chains, false, panelPath, interactionFn, itemEdited, setItemEdited, isDraggingDetails, insetWidth, insetHeight, dragStart, dragEnd, onDrag, isShowingSomeDropDown, currentList, otherPeoplesPositions, updatesToPropagate, organicChanges, userNos, userID, getRef1, refObject, error, internalVariables, clickEditItem, onClickItemChangeSelection, inputValues, setInputValues, ownVariables, urlParamsForExecution, urlHeader, setIsShowingSomeDropDown, setIsClickingOnContentDiv, upwardInfo, isClickingOnContentDiv, addWhereText, potentiallyAddWhichItem, hoveringWhere, actHoveringWhere, screenSelectionChoices, setScreenSelectionChoices, popUps, setPopUps, showRelatives, doAScreenRef, flashHighlight, lastEdited, counter);
  relativePieces = relativeItemsSet.expressedItems;

  if (!interactionFn){
    if (addWhereText === 'PANEL' && potentiallyAddWhichItem && potentiallyAddWhichItem.t !== 'navBar' && potentiallyAddWhichItem.t !== 'ALERT' && isThisPanelItemEdited){
      addRelativePiece = <div className='dropSpace'>Click and {potentiallyAddWhichItem.t} will appear here.</div>
//
    }else if (relativePieces.length === 0){
      var tile = 'Panel';
      if (panelPath.length === 1 && panelPath[0] === 'fo'){
        tile = 'Footer';
      }
      var m1 = 'Click to Edit.';
      if (isThisPanelEdited){
        m1 = 'Use the "Add Items" tab to add items.';
      }
      addRelativePiece = <div style={{padding:'5px', textAlign:'center', color:'#A2A2A2'}}>Empty {tile}. {m1}</div>
    }
  }

//
  style.zIndex = 0;
//
  var overallDraggable = false;
  if (isThisPanelEdited){
    overallDraggable = true;
    aScreenStyle.pointer = 'move';
  }


  function oDragStart(e){
    itemEdited.d = true;
    setItemEdited({...itemEdited})
  }

  function oDragEnd(e){
    delete itemEdited.d;
    setItemEdited({...itemEdited})
  }


  aScreenStyle.textAlign = 'left';
  return <div ref={ref1} className={screenClassNames} style={{...style, ...aScreenStyle}} draggable={overallDraggable} onDragStart={oDragStart} onDragEnd={oDragEnd} onClick={clickScreen} >
          {alertPieces}
          {movementPieces}
          {relativePieces}
          {frontExpressedItems}
          {addRelativePiece}
        </div>
}


export default App;
